import PlatformStateHistoryGatewayInterface from '../../domain/PlatformStateHistory/PlatformStateHistoryGatewayInterface'
import { PlatformStateHistoryInterface } from '../../domain/PlatformStateHistory/PlatformStateHistory'

export type GetPlatformStateHistoryCommand = {
  dossierId: string
}

export default class GetPlatformStateHistoryUseCase {
  constructor(private readonly platformStateHistoryGateway: PlatformStateHistoryGatewayInterface) { }

  async handle(getPlatformStateHistoryCommand: GetPlatformStateHistoryCommand): Promise<PlatformStateHistoryInterface[] | null> {
    const response = await this.platformStateHistoryGateway.retrieveList(getPlatformStateHistoryCommand.dossierId)
    if (response) {
      return response
    }
    return null
  }
}
